'use client'

import Link from 'next/link';
import { t as systemText } from '../i18n';

export default function Error({ error, reset }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-md rounded-lg p-6">
        <h1 className="text-xl font-bold text-red-600 mb-4">{systemText("Error")}</h1>
        <p className="text-gray-600 mb-4">
          {error?.message || systemText("Something went wrong. Please try again.")}
        </p>
        <div className="space-y-2">
          <button
            onClick={() => reset()}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors"
          >
            {systemText("Try again")}
          </button>
          <Link
            href="/"
            className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded transition-colors block text-center"
          >
            {systemText("Go home")}
          </Link>
        </div>
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-4">
            <summary className="cursor-pointer text-sm text-gray-500">{systemText("Error details")}</summary>
            <pre className="mt-2 text-xs bg-gray-100 p-2 rounded overflow-auto max-h-32">
              {error?.stack}
            </pre>
          </details>
        )}
      </div>
    </div>
  )
}